function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{font-size:51.69px;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#231f20;font-family:futura-pt, sans-serif;}.cls-4{font-size:51.69px;}.cls-5{font-size:51.69px;}.cls-6{font-size:51.69px;}.cls-7{font-size:51.69px;}.cls-8{font-size:51.69px;}.cls-9{font-size:51.69px;}.cls-10{font-size:51.69px;}.cls-11{font-size:51.69px;}.cls-12{font-size:51.69px;}.cls-13{font-size:51.69px;}.cls-14{font-size:51.69px;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 500,
  height: 500
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Artwork_21",
  "data-name": "Artwork 2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(135.44 104.24) rotate(-33.24)"
}, "L"), /*#__PURE__*/React.createElement("text", {
  className: "cls-4",
  transform: "translate(164.22 84.85) rotate(-20.32)"
}, "O"), /*#__PURE__*/React.createElement("text", {
  className: "cls-5",
  transform: "translate(204.71 69.61) rotate(-7.28)"
}, "R"), /*#__PURE__*/React.createElement("text", {
  className: "cls-6",
  transform: "translate(244.72 64.43) rotate(4.15)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls-7",
  transform: "translate(282.17 66.83) rotate(16.72)"
}, "N"), /*#__PURE__*/React.createElement("text", {
  className: "cls-8",
  transform: "translate(323.43 79.56) rotate(29.07)"
}, "Z"), /*#__PURE__*/React.createElement("text", {
  className: "cls-9",
  transform: "translate(355.66 98.36) rotate(37.27)"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls-10",
  transform: "translate(370.12 108.04) rotate(46.93)"
}, "K"), /*#__PURE__*/React.createElement("text", {
  className: "cls-11",
  transform: "matrix(0.51, 0.86, -0.86, 0.51, 399.46, 139.75)"
}, "L"), /*#__PURE__*/React.createElement("text", {
  className: "cls-4",
  transform: "translate(417.1 169.49) rotate(69.68)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls-12",
  transform: "translate(429.22 204.78) rotate(78.38)"
}, "I"), /*#__PURE__*/React.createElement("text", {
  className: "cls-13",
  transform: "translate(434.07 224.47) rotate(88.46)"
}, "S"), /*#__PURE__*/React.createElement("text", {
  className: "cls-14",
  transform: "translate(435.36 261.91) rotate(99.78)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls-14",
  transform: "translate(429.03 298.8) rotate(110.85)"
}, "R")));
function SvgLogoOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOuter);
export default __webpack_public_path__ + "static/media/LogoOuter.93ea85e0.svg";
export { ForwardRef as ReactComponent };